import React from 'react';
import { Hero, Testimonials, Problem } from './components/Sections1';
import { Product, Bonuses } from './components/Sections2';
import { Pricing } from './components/Sections3';
import { Guarantee, FAQ, CostOfInaction, Footer } from './components/Sections4';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-cream-50 text-navy selection:bg-teal-500/25" data-id="element-0" data-mp="3f8nedijx7b8k">
      <main data-id="element-1" data-mp="2rl6y5e9xj6xz">
        <Hero data-id="element-2" data-mp="2rikmb2g0a59y" />
        <Testimonials data-id="element-3" data-mp="2mm2m8fvmev3y" />
        <Problem data-id="element-4" data-mp="2mmlvl877gb6d" />
        <Product data-id="element-5" data-mp="2mn5a0exnchfn" />
        <Bonuses data-id="element-6" data-mp="2mnngs5hxqe1t" />
        <Pricing data-id="element-7" data-mp="2mjzn96chprn3" />
        <Guarantee data-id="element-8" data-mp="31agp2qt1ejki" />
        <FAQ data-id="element-9" data-mp="31ayv2f5i4c5m" />
        <CostOfInaction data-id="element-10" data-mp="31bi9hlvy0iew" />
      </main>
      <Footer data-id="element-11" data-mp="31cjo20c63n1d" />
    </div>;
}